import React from 'react';
import { Box, Button, HStack, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { SessionDataType } from '../../../../models/m6-2';

interface Props {
  onChoose: (dataType: SessionDataType) => void;
  onSkip?: () => void;
}

const CHOICES: Array<{
  type: SessionDataType;
  icon: string;
  label: string;
  hint: string;
}> = [
  {
    type: 'gps_full',
    icon: '📡',
    label: 'GPS completo',
    hint: 'tracking squadra',
  },
  { type: 'cardio_only', icon: '❤️', label: 'Cardio puro', hint: 'solo HR' },
  {
    type: 'running_cycling',
    icon: '🏃',
    label: 'Corsa/Cycling',
    hint: 'attività personale',
  },
  { type: 'manual', icon: '✍️', label: 'Manuale', hint: 'nessun file' },
];

/**
 * Banner scelta manuale tipo dato quando auto-detect confidence < 0.5
 * (M6.2 B12 Fase 4 fallback safe).
 */
export function DataTypeFallbackChooser({ onChoose, onSkip }: Props) {
  return (
    <Box
      borderWidth={1}
      borderColor="orange.400"
      borderRadius="md"
      bg="orange.50"
      p={4}
      mb={3}
    >
      <VStack align="stretch" gap={3}>
        <Text fontWeight="semibold" color="orange.800">
          Non sono sicuro del tipo di dato
        </Text>
        <Text fontSize="sm" color="orange.700">
          Scegli tu la categoria giusta:
        </Text>
        <SimpleGrid columns={{ base: 1, md: 4 }} gap={2}>
          {CHOICES.map((c) => (
            <Button
              key={c.type}
              variant="outline"
              size="sm"
              onClick={() => onChoose(c.type)}
              flexDirection="column"
              height="auto"
              py={3}
              bg="var(--c-card-bg)"
            >
              <Text fontSize="lg">{c.icon}</Text>
              <Text fontSize="sm" fontWeight="semibold">
                {c.label}
              </Text>
              <Text fontSize="xs" opacity={0.7}>
                {c.hint}
              </Text>
            </Button>
          ))}
        </SimpleGrid>
        {onSkip && (
          <HStack justify="flex-end">
            <Button variant="ghost" size="sm" onClick={onSkip}>
              Non è nessuno di questi · procedi generico
            </Button>
          </HStack>
        )}
      </VStack>
    </Box>
  );
}
